import { Component, computed, inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Router } from '@angular/router';
import { PaymentDetailsComponent } from '../payment-details/payment-details.component';
import { ContactComponent } from 'app/shared/components/contact/contact.component';
import { Themes } from 'themes';
import { BannerComponent } from 'app/shared/components/banner/banner.component';
import { ManualPaymentComponent } from './manual-payment/manual-payment.component';
import { PaymentMethodSelectionComponent } from './payment-method-selection/payment-method-selection.component';
import { isPrivateCustomer } from 'app/shared/models/customer.model';
import {
  getSelectablePaymentTypes,
  hasManualPayment,
  SelectablePaymentType,
} from 'app/shared/models/payment-configuration.model';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { LandingpageConfigurationStateService } from 'app/shared/services/state/landingpage-configuration-state.service';

@Component({
  selector: 'ez-overview',
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.scss',
  imports: [
    MainLayoutComponent,
    ManualPaymentComponent,
    PaymentMethodSelectionComponent,
    PaymentDetailsComponent,
    ContactComponent,
    BannerComponent,
  ],
})
export class OverviewComponent {
  private readonly logger = inject(NGXLogger);
  private readonly router = inject(Router);

  readonly hasManualPayment = hasManualPayment;
  readonly landingpageConfig = inject(LandingpageConfigurationStateService).landingpageConfiguration;

  readonly paymentMethods = computed<SelectablePaymentType[]>(() => {
    const landingpageConfig = this.landingpageConfig();
    return landingpageConfig
      ? getSelectablePaymentTypes(landingpageConfig.paymentConfiguration.allowedPaymentTypes)
      : [];
  });

  protected readonly Themes = Themes;

  chosePaymentMethod(paymentMethod: SelectablePaymentType) {
    this.logger.debug(`Chosen payment method: ${paymentMethod}`);
    switch (paymentMethod) {
      case 'CREDIT_CARD':
        break;
      case 'SEPA':
        this.router.navigate(['payment', 'sepa']);
        break;
      case 'GIRO':
        break;
      case 'PAYPAL':
        this.router.navigate(['payment', 'paypal']);
        break;
    }
  }

  protected readonly isPrivateCustomer = isPrivateCustomer;
}
